
































import vue from "vue";
import {
  VUEX_EXERCISE_ACTION_NAMES,
  VUEX_EXERCISE_GETTER_NAMES,
  VUEX_EXERCISE_NAMESPACE
} from "@tt-app/constants";

import BaseExerciseFooter from "@tt-app/components/exercise/consolidated/exercise/footer/BaseExerciseFooter.vue";
import ExerciseFooter from "@tt-app/components/exercise/common/ExerciseFooter.vue";
import ExerciseMiniSettings from "@tt-app/components/exercise/consolidated/exercise/footer/ExerciseMiniSettings.vue";
import ExerciseTextArea from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseTextArea.vue";
import HintsSetting from "@tt-app/components/exercise/consolidated/exercise/footer/HintsSetting.vue";
import ExerciseHints from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHints.vue";

const { LOG_ANSWER, SETTINGS_POPUP_TOGGLE } = VUEX_EXERCISE_ACTION_NAMES;

const { CURRENT_PAGE } = VUEX_EXERCISE_GETTER_NAMES;

interface Data {
  answer: string;
}

interface Methods {
  handleCheckClick: () => void;
  handleSkipClick: () => void;
  handleSettingsClick: () => void;
  resetInput: () => void;
}

interface Computed {
  derivedDisable: boolean;
  hideSettings: boolean;
  hideSkip: boolean;
  hints: string[];
}

interface Props {
  disabled: any;
}

export default vue.extend<Data, Methods, Computed, Props>({
  name: "WritingFooter",

  components: {
    ExerciseHints,
    HintsSetting,
    ExerciseMiniSettings,
    BaseExerciseFooter,
    ExerciseFooter,
    ExerciseTextArea
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      answer: ""
    };
  },

  methods: {
    async handleCheckClick() {
      const payload = {
        answer: this.answer
      };

      await this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${LOG_ANSWER}`, payload);

      this.resetInput();
    },

    async handleSkipClick() {
      const payload = {
        skipped: true
      };

      await this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${LOG_ANSWER}`, payload);
    },

    async handleSettingsClick() {
      await this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${SETTINGS_POPUP_TOGGLE}`);
    },

    resetInput() {
      this.answer = "";
    }
  },

  computed: {
    derivedDisable() {
      return this.answer.trim().length <= 0 || this.disabled;
    },

    hideSettings() {
      return this.hints?.length <= 0;
    },

    hideSkip() {
      return false;
    },

    hints() {
      const currentPage = this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${CURRENT_PAGE}`];

      return currentPage?.hints || [];
    }
  }
});
